<div class="toolbar flex flex-row bg-secondary">
  <div class="flex flex-row">
    <button
      mat-icon-button
      class="icon icon-menu"
      aria-label="icon-button with menu icon"
      (click)="toggleSideNav()"
    >
      <mat-icon class="text-white center-menu-icon">menu</mat-icon>
    </button>
    <a routerLink="/" class="flex flex-row">
      <img src="assets/mhe-logo.jpg" alt="mhe-logo" class="mhe-logo" />    
      <span class="text-white text-base my-auto"> {{ title }}</span>
    </a>
  </div>
  <div class="flex flex-auto flex-row justify-end">
    <div class="mx-2 flex flex-row items-center px-2 user-info-container">
      <div class="flex flex-row items-center gap-3">
        <div class="text-grey-c user-name">
          {{ user.name | titlecase }}
        </div>
        @if (businessUnit) {
          <dal-provider-bu-inline-selector [businessUnit]="businessUnit" [businessUnits]="businessUnits"
            (businessUnitChange)="businessUnitChange.emit($event)"></dal-provider-bu-inline-selector>
        }
      </div>
      <span class="material-symbols-outlined ml-2 text-white text-[32px]">
        account_circle
      </span>
    </div>

    <!-- Search Component - Requires 'Search' permission -->
    <div *dalHasAnyPermission="['Search']">
      <dal-shared-ui-search
        (searchEvent)="search($event)"
        [SearchLabel]="'Search...'"
        [showIcon]="true"
      ></dal-shared-ui-search>
    </div>
    
    <!-- Activity Queue Button - Requires 'Activities' permission -->
    <img
      *dalHasAnyPermission="['Activities']"
      src="assets/spinner-loader.svg"
      alt="active queue"
      class="mhe-logo -scale-x-[1]"
      (click)="toggleActivityQueue()"
    />
  </div>
</div>
<!-- Activity Queue Panel - Requires 'Activities' permission -->
<ng-container *dalHasAnyPermission="['Activities']">
  @if (showActivityQueue) {
  <dal-shared-mini-ui-activity-queue
      [activities]="activities"
      (deleteActivity)="deleteActivityQueue($event)"
      (pauseActivity)="pauseActivityQueue($event)"
      (resumeActivity)="resumeActivityQueue($event)"
      (cancelActivity)="cancelActivityQueue($event)"
      (closeActivity)="toggleActivityQueue()"
      ></dal-shared-mini-ui-activity-queue>
  }
</ng-container>
